import { BackgroundColors } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

// import { BreakPoints } from '@picsart/design-system/foundation/responsive';

const useStyles = createUseStyles(
  () => ({
    root: {
      position: 'relative',
      padding: [Spacings.s72, Spacings.s0],
      backgroundColor: BackgroundColors.base,
      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        padding: [Spacings.s56, Spacings.s0, Spacings.s40],
      },
    },

    title: {
      maxWidth: 1066,
      padding: [Spacings.s0, Spacings.s24],
      margin: 'auto',
      marginBottom: Spacings.s16,
      fontSize: FontSizes.s42,
      lineHeight: LineHeights.l50,
      textAlign: 'center',

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        marginBottom: Spacings.s8,
        fontSize: FontSizes.s24,
        lineHeight: LineHeights.l28,
      },
      '&.skeleton': {
        height: 90,
        // [mediaQuery(767)]: {
        '@media screen and (max-width: 767px)': {
          height: 54,
        },
      },
    },

    description: {
      padding: [Spacings.s0, Spacings.s32],
      fontSize: FontSizes.s20,
      textAlign: 'center',
      lineHeight: LineHeights.l32,
      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        fontSize: FontSizes.s20,
        lineHeight: LineHeights.l32,
      },
      '&.skeleton': {
        margin: 'auto',
        width: 250,
        height: 40,
      },
    },

    imageTabs: {
      position: 'relative',
      width: '100%',
      maxWidth: 1192,
      margin: [84, 'auto', Spacings.s0],

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        marginTop: 66,
      },
      '&.skeleton': {
        height: 420,
        // [mediaQuery(767)]: {
        '@media screen and (max-width: 767px)': {
          height: 234,
        },
      },
    },

    foreground: {
      position: 'absolute',
      width: 314,
      height: 340,
      bottom: Spacings.s0,
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 1,
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        width: 266,
        height: 260,
      },
      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        width: 230,
        height: 200,
      },
    },

    imageContainer: {
      position: 'relative',
      width: '100%',
      height: 634,
      maxHeight: 422,
      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        margin: 'auto',
        maxWidth: 360,
        width: '100%',
        maxHeight: 234,
      },
    },

    pictureClassName: {
      width: '100%',
    },
  }),
  {
    name: 'interactive-images',
  },
);

export default useStyles;
